<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-layout column wrap xs6>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.stdRiskTxtMenu.title}}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.itemNo}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.stdItemTxtMenu.title}}</div>
            </v-flex>
            <v-flex xs6 v-if="!newStdSubItemTxt">
              <v-subheader class="queryLabel">{{labels.subItemNo}}</v-subheader>
              <div class="title">{{this.stdRiskSubItemTxtForm.subItemNo}}</div>
            </v-flex>
            <v-flex xs6 v-else>
              <v-autocomplete :label="labels.subItemNo" v-model="stdRiskSubItemTxtForm.subItemNo" :items="itemList" :error-messages="errors.first('scheme') ? errors.first('scheme') : errors.collect('subItemNo')" data-vv-name="subItemNo" :data-vv-as="labels.subItemNo" v-validate="'required'" :loading="itemLoading"></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="labels.subItemDesc" v-model="stdRiskSubItemTxtForm.subItemDesc" :error-messages="errors.collect('subItemDesc')" v-validate="'required|entry'" data-vv-name="subItemDesc" :data-vv-as="labels.subItemDesc"></v-text-field>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
        {{ newStdSubItemTxt ? 'Save SubItem Text' : 'Update SubItem Text' }}
        <v-icon right>{{newStdSubItemTxt ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        riskNo: 'Risk No',
        itemNo: 'Item No',
        subItemNo: 'SubItem No*',
        subItemDesc: 'Standard SubItem Text Description*'
      },
      stdRiskSubItemTxtForm: {
        scheme: null,
        riskNo: null,
        itemNo: null,
        subItemNo: null,
        subItemDesc: null
      },
      newStdSubItemTxt: false,
      itemList: [],
      stdItemTxt: [],
      itemLoading: false,
      textLoading: false,
      previewText: '',
      submitting: false
    }
  },
  computed: {
    stdItemTxtMenu() {
      return this.$store.state.parameters.scheme.stdItemTxtMenu
    }
  },
  watch: {
    'ids.subItemNo': function (value) {
      this.resetMessages()
      this.resetValidator()
      this.doClearForm()
      this.stdRiskSubItemTxtForm.scheme = this.ids.scheme
      this.stdRiskSubItemTxtForm.riskNo = this.ids.riskNo
      this.stdRiskSubItemTxtForm.itemNo = this.ids.itemNo
      Promise.all([this.doItemList()])
      if (value !== 'new') {
        this.newStdSubItemTxt = false
        if (value !== null) {
          this.fetchData(value)
        }
      } else {
        this.newStdSubItemTxt = true
      }
    }
  },
  methods: {
    async fetchData(subItemNo) {
      const apiURI = this.stdItemTxtMenu.menu.pkgStdSubItemTxt
      if (apiURI) {
        const expand = {
          scheme: this.ids.scheme,
          riskNo: this.ids.riskNo,
          itemNo: this.ids.itemNo,
          subItemNo: subItemNo
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.stdRiskSubItemTxtForm.scheme = data.pkgStdSubItemTxt.scheme
            this.stdRiskSubItemTxtForm.riskNo = data.pkgStdSubItemTxt.riskNo
            this.stdRiskSubItemTxtForm.itemNo = data.pkgStdSubItemTxt.itemNo
            this.stdRiskSubItemTxtForm.subItemNo = data.pkgStdSubItemTxt.subItemNo
            this.stdRiskSubItemTxtForm.subItemDesc = data.pkgStdSubItemTxt.subItemDesc
            this.menu = extractMenu(result.data._links)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Standard SubItem Text Review')
      }
    },
    async doItemList() {
      const apiURI = this.stdItemTxtMenu.menu.subItemList
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme,
            riskNo: this.ids.riskNo,
            itemNo: this.ids.itemNo
          }
          this.itemLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.itemList = data.subItemList
          }
          this.itemLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Standard SubItem Text List')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.stdRiskSubItemTxtForm.scheme = this.ids.scheme
      this.stdRiskSubItemTxtForm.riskNo = null
      this.stdRiskSubItemTxtForm.itemNo = null
      this.stdRiskSubItemTxtForm.subItemNo = null
      this.stdRiskSubItemTxtForm.subItemDesc = null
      this.previewText = ''
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newStdSubItemTxt) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.stdItemTxtMenu.menu.pkgStdSubItemTxtCreate
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.stdRiskSubItemTxtForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 3)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.pkgStdSubItemTxtUpdate
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.stdRiskSubItemTxtForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 3)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          riskNo: null,
          itemNo: null,
          stdRiskTxt: null
        }
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
